import "./Home.module.css";
import Encabezado from "@/reusable_sections/Header";
import Header from "./sections/Header";
import ReturnToBeingAChildHero from "./sections/ReturnToBeingAChildHero";
import GestionEn3Pasos from "./sections/GestionEn3Pasos";
import ProtocolosDeConfianza from "./sections/ProtocolosDeConfianza";
import PreguntasFrecuentes from "./sections/PreguntasFrecuentes";
import LlamadoAlBienestar from "./sections/LlamadoAlBienestar";
import PieDePagina from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Encabezado />
      <Header />
      <ReturnToBeingAChildHero />
      <GestionEn3Pasos />
      <ProtocolosDeConfianza />
      <PreguntasFrecuentes />
      <LlamadoAlBienestar />
      <PieDePagina />
    </div>;
}